import { useAppDispatch, useAppSelector } from 'src/hooks/store';
import { Button, Spacer } from '@odekoteam/doppio';
import CancelButton from '../CancelButton';
import { Flex } from 'theme-ui';
import { useEffect, useState } from 'react';
import { modalSelector } from 'src/state/selectors/modal';
import { GetLocation } from 'src/graphql/types/delivery';
import { GUpdateLocationsServiceTimeMutation } from 'src/graphql/types/generated';
import { useMutation } from 'urql';
import { UPDATE_LOCATIONS_SERVICE_TIME } from 'src/graphql/requests/updateLocationsServiceTime';
import { hideModal } from 'src/state/slices/modal';
import { LoaderSpinner } from '../../Loader';
import { updateRoutingLocations } from 'src/state/slices/locations';
import ExpandableLocationsList from './ExpandableLocationsList';

const LocationServiceTimeTab = (): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const {
    variables: { locations },
  } = useAppSelector(modalSelector);
  const [serviceTime, setServiceTime] = useState<number>(5); // Set default to 5 minutes
  const getLabel = (): string =>
    `${serviceTime} minute${serviceTime === 1 ? '' : 's'}`;
  const [updateLocationsServiceTimeResult, updateLocationsServiceTime] =
    useMutation<GUpdateLocationsServiceTimeMutation>(
      UPDATE_LOCATIONS_SERVICE_TIME,
    );

  const handleServiceTimeChange = (value: string): void => {
    const numValue = parseInt(value, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 60) {
      setServiceTime(numValue);
    }
  };

  const handleAction = (): void => {
    const locationIds = locations.map(
      (location: GetLocation): string => location.id,
    );
    updateLocationsServiceTime({
      input: {
        locationIds,
        serviceTime,
      },
    });
  };

  useEffect(() => {
    if (updateLocationsServiceTimeResult.data) {
      const routingLocations = locations.map((location: GetLocation) => ({
        locationId: location.id,
        serviceTime: serviceTime,
      }));
      dispatch(updateRoutingLocations(routingLocations));
      dispatch(hideModal());
    }
  }, [updateLocationsServiceTimeResult]);

  return (
    <>
      <Flex sx={{ alignItems: 'center', marginBottom: '10px' }}>
        <span sx={{ variant: 'text.paragraphMdDefault' }}>
          Update location service time to
        </span>
        <div sx={{ marginX: '8px' }}>
          <input
            type="number"
            id="service-time-input-bulk"
            min="1"
            max="60"
            value={serviceTime}
            onChange={(e): void => handleServiceTimeChange(e.target.value)}
            style={{
              width: '60px',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              textAlign: 'center',
            }}
            aria-label="service time in minutes"
          />
        </div>
        <span sx={{ variant: 'text.paragraphLgDefault' }}>minutes</span>
      </Flex>
      <div sx={{ variant: 'text.paragraphMdDefault', marginBottom: '20px' }}>
        You will be updating {locations.length} locations. Would you like to
        update service time to{' '}
        <b sx={{ variant: 'text.labelMd' }}>{getLabel()}</b> for these{' '}
        {locations.length} locations?
      </div>
      <ExpandableLocationsList locations={locations} />
      <Flex sx={{ justifyContent: 'center', marginTop: '24px' }}>
        {updateLocationsServiceTimeResult.fetching && (
          <LoaderSpinner
            imgStyle={{
              marginLeft: '-200px',
              bottom: '32px',
              height: '20px',
              top: 'auto',
              left: 'auto',
            }}
          />
        )}
        <Button
          id="modal-update-automated-routing-action-button"
          variant="secondary"
          onPress={handleAction}
          isDisabled={updateLocationsServiceTimeResult.fetching}
        >
          Update
        </Button>
        <Spacer width="$1" />
        <CancelButton />
      </Flex>
    </>
  );
};
export default LocationServiceTimeTab;
